import { render, staticRenderFns } from "./DonutChart07.vue?vue&type=template&id=15a25942&scoped=true"
import script from "./DonutChart07.vue?vue&type=script&lang=js"
export * from "./DonutChart07.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a25942",
  null
  
)

export default component.exports